import { render, staticRenderFns } from "./maintainanceTaskTransfer.vue?vue&type=template&id=196badf8"
import script from "./maintainanceTaskTransfer.vue?vue&type=script&lang=js"
export * from "./maintainanceTaskTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports